import React from "react";
import logo from "../../../images/Logo-FAV-gGmbH.jpg";
import { Flex, Image } from "antd";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Flex align={"center"} justify={"center"}>
      <Link to={"/"}>
        <Image src={logo} preview={false} width={120} />
      </Link>
    </Flex>
  );
};

export default Logo;
